import React from 'react';
import PortfolioCard from './PortfolioCard'

const Portfolio = () => {
    return (
        <section id="portfolio"  className="section-bg" >
            <div className="container">
                <header className="section-header">
                    <h3 className="section-title" style={{color: "#fff"}}>Our Portfolio</h3>
                </header>
                <div className="row portfolio-container">
                    <PortfolioCard image_name="demag-ac-300.jpg" title="DEMAG AC 300"/>
                    <PortfolioCard image_name="demag-AC-615.jpg" title="DEMAG AC 615"/>
                    <PortfolioCard image_name="sanny-sac-2200.jpg" title="SANY SAC 2200"/>
                    <PortfolioCard image_name="sany-qay-220.jpg" title="SANY QAY 220"/>
                    <PortfolioCard image_name="demag-hc-400.jpg" title="DEMAG HC 400"/>
                    <PortfolioCard image_name="demag-hc-360.jpg" title="DEMAG HC 360"/>
                    <PortfolioCard image_name="luna-43_120.jpg" title="LUNA 120"/>
                    <PortfolioCard image_name="krupp-kmk-5110.jpg" title="KRUPP KMK 5110"/>
                    <PortfolioCard image_name="sany-stc-800s.jpg" title="SANY STC 800S"/>
                    <PortfolioCard image_name="krupp-KMK-4070.jpg" title="KRUPP KMK 4070"/>
                    <PortfolioCard image_name="T 750.jpg" title="T 750"/>
                </div>
            </div>
        </section>
    );
}

export default Portfolio;